import script from "./PricingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPage.vue?vue&type=script&setup=true&lang=js"

import "./PricingPage.vue?vue&type=style&index=0&id=798bc8f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798bc8f8"]])

export default __exports__